import * as React from 'react';
import {useEffect} from 'react';
import {styled} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import reicon from '../../assets/main/reicon.png';
import write from '../../assets/main/write.png';
import center from '../../assets/main/center.png';
import {useNavigate} from "react-router-dom";
import * as util from "../../utils/util";
import api from "../../utils/api";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Skeleton from '@mui/material/Skeleton';

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const TopMan = styled('img')({
  marginLeft: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const topMan = {
  position: 'relative',
  top: '74px',
  right: '14px'
}

const topContainer = {
  height: 295,
  backgroundImage: `url(${"../../src/assets/main/mainTop.png"})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat'
};

const MainResult = () => {

  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [reservationList, setReservationList] = React.useState([{
    famGrade: '', firstWishDate: '', ipDate: '', hoName: '',
    famName: '', rsvName: '', hoImage: '', rsvId: '', reservationStatus: { code: -999, name: '' }
  }]);

  useEffect(() => {

    setLoading(true);
    // 예약 목록
    if (util.strNull(window.localStorage.userCusID) !== '') {
      api.post('customer/api/v1/CU_004_001', { cusId: window.localStorage.userCusID }).then((res: any) => {
        const nowYear = new Date().getFullYear().toString();
        setReservationList(res.data.inspection.filter((v: any) => v.reservationStatus.code >= 0
          && util.strNull(v.ipDate) !== '' ? v.ipDate.startsWith(nowYear) : v.firstWishDate.startsWith(nowYear))); // 해당연도 && 예약대기, 예약확정, 수진완료, 결과등록 데이터만 출력

        setLoading(false);
      }).catch(function (error: any) {
        console.log(error)
        setLoading(false);
      });
    }else{
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, []);



  return (
    <React.Fragment>



      <Box sx={{ width: '100%' }}>

        <List sx={{ width: '100%', p: '5px 0', bgcolor: '#fff', borderRadius: '20px', m: '15px 0' }}
          onClick={() => util.strNull(window.localStorage.userCusID) !== '' ? navigate('/MyPage/HealthResult') : {}}>
          <ListItem alignItems="center" >
            <ListItemAvatar sx={{ bgcolor: '#FEF8F5', width: 64, height: 64, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {loading ? (
                <Skeleton animation="wave" variant="circular" width={64} height={64} />
              ) : (
                <Avatar alt="" src={write} sx={{ borderRadius: 0 }} />
              )}  {/* Skeleton */}
            </ListItemAvatar>

            {loading ? (
              <Stack direction={'column'} sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', width: '50%',ml: 2  }} justifyContent='center' alignContent={'center'}>
                <Skeleton animation="wave" variant="rounded" height={21} width='100%' sx={{ borderRadius: 3, }} />
                <Skeleton animation="wave" variant="rounded" height={21} width='100%' sx={{ borderRadius: 3, my: 1 }} />
              </Stack>
            ) : (
              <Stack sx={{ ml: 2 }}>
                <Typography sx={{ fontSize: 14, color: '#666' }}>건강검진 기록 한번에 보기</Typography>
                <Typography sx={{ fontSize: 18, fontWeight: 700, m: '5px 0', color: '#555' }}>건강검진 기록</Typography>
                {/*<Stack direction={'row'}>
              <RestoreOutlinedIcon sx={{fontSize:18, color:'#aaa', m:'2px 10px 0 0'}} />
              <Typography sx={{ fontSize: 14, color:'#EF8322' }}>건강검진 기록이 없습니다</Typography>
            </Stack>*/}
              </Stack>
            )}  {/* Skeleton */}
          </ListItem>

        </List>

      </Box>

      {/*
      <List sx={{ width: '100%', p:'5px 0', bgcolor: '#fff', borderRadius:'20px', }} onClick={() => navigate('../reservation')}>
        <ListItem alignItems="center" >
          <ListItemAvatar sx={{bgcolor:'#FEF8F5', width:64, height:64, borderRadius:'50%', display:'flex',alignItems:'center',justifyContent:'center'}}>
            <Avatar alt="" src={center} sx={{borderRadius:0}} />
          </ListItemAvatar>
          <Stack sx={{ ml: 2 }}>
            <Typography sx={{ fontSize: 14, color:'#666'}}>가까운 건강검진센터 찾아보기</Typography>
            <Typography sx={{ fontSize: 18, fontWeight: 700, m:'5px 0', color:'#555' }}>건강검진센터 찾기</Typography>
            <Stack direction={'row'}>
              <AddLocationOutlinedIcon sx={{fontSize:18, color:'#aaa', m:'2px 10px 0 0'}} />
              <Typography sx={{ fontSize: 14, color:'#555' }}>대전광역시 유성구</Typography>
            </Stack>
          </Stack>
        </ListItem>
      </List>
  */}
    </React.Fragment>

  );
}

export default MainResult;